import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { Wallpaper } from '../../components/Wallpaper'
import FormField from '../../components/FormField'
import { isNaturalDocumentNumber, cpfMask, isDate, isName, dateMask, nameMask, formatName, formatToYYYYMMDD } from '../../utils/utils'
import useInput from '../../utils/hooks/useInput'
import { Footer } from '../../components/Footer'
import { NotFoundDialog } from './NotFoundDialog'
import { LoadingPage } from '../LoadingPage'
import { Logo } from '../../components'
import { Button } from './styles'
import { useCookies } from 'react-cookie'

export const LoginWatcher = (props) => {
    const { clientThemeSettings, documentNumberRequired, setWatcherStep, setSignerList } = props
    const { watcherHash } = useParams()
    const [cookies, setCookie] = useCookies([`qisign_${watcherHash}`])
    const [hasMadeRequest, setHasMadeRequest] = useState(false)
    const [termsCheckboxChecked, setTermsCheckboxChecked] = useState(false)
    const handleTermsCheckboxChange = (event) => {
        setTermsCheckboxChecked(event.target.checked)
    }

    let fields = {
        document_number: {
            id: "document_number",
            name: "Número do CPF",
            errorMessage: "Número de CPF inválido.",
        },
        birthdate: {
            id: "birthdate",
            name: "Data de Nascimento (DD/MM/AAAA)",
            errorMessage: "Data de nascimento inválida."
        },
        name: {
            id: "name",
            name: "Nome completo",
            errorMessage: "Nome completo inválido."
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (documentNumberIsValid && birthdateIsValid && termsCheckboxChecked) {
                handleClick()
            }
        }
    }

    const {
        value: documentNumberValue,
        isValid: documentNumberIsValid,
        hasError: documentNumberHasError,
        valueChangeHandler: documentNumberValueChangeHandler,
        inputBlurHandler: documentNumberInputBlurHandler,
        reset: documentNumberReset
    } = useInput(isNaturalDocumentNumber)

    const {
        value: birthdateValue,
        isValid: birthdateIsValid,
        hasError: birthdateHasError,
        valueChangeHandler: birthdateValueChangeHandler,
        inputBlurHandler: birthdateInputBlurHandler,
        reset: birthdateReset
    } = useInput(isDate)

    const {
        value: nameValue,
        isValid: nameIsValid,
        hasError: nameHasError,
        valueChangeHandler: nameValueChangeHandler,
        inputBlurHandler: nameInputBlurHandler,
        reset: nameReset
    } = useInput(isName)

    const [openNotFoundDialog, setOpenNotFoundDialog] = useState(false)
    const [loading, setLoading] = useState(false)

    const onSubmit = useCallback((documentNumber, birthdate, name, alreadyFormatted) => {

        let payload = {}

        if (hasMadeRequest) {
            return 
        }

        if (documentNumber !== "" || birthdate !== "") {
            
            payload = {
                "document_number": cpfMask(documentNumber),
                "birthdate": formatToYYYYMMDD(birthdate),
            }    

            if (alreadyFormatted) {
                payload["document_number"] = documentNumber
                payload["birthdate"] = birthdate
            }
        }
        
        if (name !== null && name !== "") { 
            payload["name"] = formatName(name)
        }
        
        setLoading(true)
        setHasMadeRequest(true)
        axios.post('/watcher/hash/' + watcherHash, payload)
            .then(async (response) => {
                documentNumberReset()
                birthdateReset()
                nameReset()
                setCookie(`qisign_${watcherHash}`, payload, { path: `/w/${watcherHash}`, maxAge: 60 * 60 })
                setWatcherStep(response.data.watcher_data.watcher_status)
                setSignerList(response.data.watcher_data.signers_list)
            }).catch((error) => {
                if ([401, 403, 409].includes((error.response || {}).status)) {
                    setOpenNotFoundDialog(true)
                    setHasMadeRequest(false)
                }
                setCookie(`qisign_${watcherHash}`, '', { path: `/w/${watcherHash}`, maxAge: 0 })
            })
            .finally(() => {
                setLoading(false)
            })
    }, [setCookie, birthdateReset, documentNumberReset, nameReset, watcherHash, hasMadeRequest, setWatcherStep, setSignerList])

    useEffect(() => {
        if (cookies[`qisign_${watcherHash}`] && isNaturalDocumentNumber(cookies[`qisign_${watcherHash}`].document_number) && !hasMadeRequest) {
            onSubmit(cookies[`qisign_${watcherHash}`].document_number, cookies[`qisign_${watcherHash}`].birthdate, null, true)
        }
    }, [cookies, watcherHash, onSubmit, hasMadeRequest])

    const handleClick = () => {
        onSubmit(documentNumberValue, birthdateValue, nameValue, false)
        return
    }

    if (loading) {
        return (
            <LoadingPage clientThemeSettings={clientThemeSettings} />
        )
    }

    return (
        <Wallpaper
            backgroundColor={clientThemeSettings.background_color}
        >
            <div className="base-container base-container-width base-container-padding" style={{ backgroundColor: "rgb(245, 245, 242)" }}>
                <Logo imageSource={clientThemeSettings.logo_url} />
                <p className="description-level4 gray no-border-container-fullwidth" style={{ textAlign: "justify", marginBottom: '0px'}}>
                    Para acompanhar o progresso das assinaturas, preencha os campos abaixo:
                </p>
                <div className="no-border-container-fullwidth">
                    {documentNumberRequired === true ?
                     (<>
                        <FormField
                            labelValue={fields.document_number.name}
                            onChange={documentNumberValueChangeHandler}
                            onBlur={documentNumberInputBlurHandler}
                            hasError={documentNumberHasError}
                            fieldValue={cpfMask(documentNumberValue)}
                            errorMessage={fields.document_number.errorMessage}
                            onKeyDown={handleKeyDown}
                            type="numeric"
                        />
                        <FormField
                            labelValue={fields.birthdate.name}
                            onChange={birthdateValueChangeHandler}
                            onBlur={birthdateInputBlurHandler}
                            hasError={birthdateHasError}
                            fieldValue={dateMask(birthdateValue)}
                            errorMessage={fields.birthdate.errorMessage}
                            onKeyDown={handleKeyDown}
                            type="numeric"
                        />
                     
                     </>): 
                     (
                        <FormField
                            labelValue={fields.name.name}
                            onChange={nameValueChangeHandler}
                            onBlur={nameInputBlurHandler}
                            hasError={nameHasError}
                            fieldValue={nameMask(nameValue)}
                            errorMessage={fields.name.errorMessage}
                            onKeyDown={handleKeyDown}
                            type="text"
                        />
                     )
                    }
                    <div className="checkbox-container" style={{marginTop: "12px"}}>
                        <input
                            type="checkbox"
                            id="termsCheckbox"
                            onChange={handleTermsCheckboxChange}
                            checked={termsCheckboxChecked}
                            onKeyDown={handleKeyDown}
                            style={{ transform: 'scale(1.5)', marginRight: '5px' }}

                        />
                        <label htmlFor="termsCheckbox" style={{ marginLeft: '8px', textAlign: 'justify' }}>
                            Concordo com os <a href="https://sign.qitech.com.br/docs/termos_de_uso.pdf" target="_blank" rel="noreferrer">Termos de Uso</a> e <a href="https://sign.qitech.com.br/docs/politica_de_privacidade.pdf" target="_blank" rel="noreferrer">Política de Privacidade</a>.
                        </label>
                    </div>
                    <Button
                        onClick={handleClick}
                        type='primary'
                        disabled={documentNumberRequired ? (!documentNumberIsValid || !birthdateIsValid || !termsCheckboxChecked): (!nameIsValid || !termsCheckboxChecked)}
                        clientThemeSettings={clientThemeSettings}
                    >
                        INICIAR
                    </Button>
                </div>
                <Footer />
            </div>
            {openNotFoundDialog &&
                <NotFoundDialog
                    open={openNotFoundDialog}
                    onClose={() => setOpenNotFoundDialog(false)}
                    clientThemeSettings={clientThemeSettings}
                />}
        </Wallpaper>
    )
}
